import { FC } from 'react';

import Button from '@components/uiKit/Button';
import { Chip } from '@components/uiKit/Chip';
import { Modal } from '@components/uiKit/Modal';
import { Radio } from '@components/uiKit/Radio';

import styles from './CitySelector.module.scss';
import { CitySelectorProps } from './types';

const CitySelector: FC<CitySelectorProps> = ({ cityOptions, isCityPopupOpen, onOpen, onClose, onSelect }) => (
    <>
        <div className={styles.citySelector_mobileCitySelect}>
            <Button
                variant="secondaryWhite"
                size="md"
                className={styles.citySelector_mobileCityButton}
                aria-haspopup="dialog"
                aria-expanded={isCityPopupOpen}
                aria-controls="contacts-city-popup"
                onClick={onOpen}
            >
                Выбрать город
            </Button>
        </div>
        <div className={styles.citySelector_tabs} role="tablist" aria-label="Город">
            {cityOptions.map(city => (
                <Chip
                    key={city.id}
                    variant="outline"
                    isActive={city.isActive}
                    size="lg"
                    role="tab"
                    aria-selected={city.isActive}
                    onClick={() => onSelect(city.id)}
                >
                    {city.label}
                </Chip>
            ))}
        </div>
        <Modal
            isOpen={isCityPopupOpen}
            onClose={onClose}
            mobileType="bottom"
            title="Доступные города"
            closeButtonAriaLabel="Закрыть"
            customCss={{ contentClassName: styles.citySelector_mobilePopupBody }}
        >
            <ul id="contacts-city-popup" className={styles.citySelector_mobilePopupList}>
                {cityOptions.map(city => (
                    <li key={city.id} className={styles.citySelector_mobilePopupItem}>
                        <Radio
                            label={city.label}
                            variant="row"
                            checked={city.isActive}
                            className={styles.citySelector_mobilePopupOption}
                            onClick={() => onSelect(city.id)}
                        />
                    </li>
                ))}
            </ul>
        </Modal>
    </>
);

export default CitySelector;
